import { Component, Inject, OnInit } from '@angular/core';
import { LoaderService } from 'Core/services/loader.service';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'bath-dream';

  constructor(
    public demoService: LoaderService,
    private translateService: TranslateService,
    private config: PrimeNGConfig,
  ) {
    this.translateService.addLangs(['ru']);
    this.translateService.setDefaultLang('ru');

    this.translateService
      .stream('primeng')
      .subscribe((res) => this.config.setTranslation(res));
  }
}
